module.exports = __webpack_public_path__ + "static/media/avatar-testimony-4.a4cb721d.png";